import { buildAuthor } from '@components/app/AuthorBox/buildAuthor'
import StructuredData from '@components/app/StructuredData'
import Routes from '@lib/routes'
import absoluteUrl from '@lib/routes/helpers/absoluteUrl'
import type { TrialInDatabaseForAlgolia } from '@modules/trials/types/TrialInDatabaseForAlgolia'
import { jsonLdScriptProps } from 'react-schemaorg'
import type { Article } from 'schema-dts'

const authorName = 'Michael Gill'
const authorDescription =
  'Michael Gill holds a Bachelors of Science in Integrated Science and Mathematics from McMaster University. During his degree he devoted considerable time modeling the pharmacodynamics of promising drug candidates. Since then, he has leveraged this knowledge of the investigational new drug ecosystem to help his father navigate clinical trials for multiple myeloma, an experience which prompted him to co-found Power Life Sciences: a company that helps patients access randomized controlled trials.'
const firstPublished = new Date('October 9, 2021').toISOString()
const lastReviewed = new Date('July 3, 2024').toISOString()

export default function ArticleStructuredData({
  trial,
}: {
  trial: Pick<
    TrialInDatabaseForAlgolia,
    'slug' | 'nlpBriefSummary' | 'briefTitle' | 'briefSummary'
  >
}) {
  return (
    <StructuredData
      id={`${trial.slug}-article`}
      scriptTagProps={jsonLdScriptProps<Article>({
        '@context': 'https://schema.org',
        '@type': 'Article',
        'author': buildAuthor({
          authorDescription,
          authorName,
          url: absoluteUrl(Routes.aboutMichaelGill),
        }),
        'dateModified': lastReviewed,
        'datePublished': firstPublished,
        'description': trial.nlpBriefSummary ?? trial.briefSummary,
        'editor': buildAuthor({
          authorDescription,
          authorName,
          url: absoluteUrl(Routes.aboutMichaelGill),
        }),
        'headline': trial.briefTitle,
        'inLanguage': 'en-US',
      })}
    />
  )
}
